import React, { useEffect } from "react";
import { getAuth, signInWithEmailAndPassword, sendEmailVerification } from "firebase/auth";

export default function SendVerificationEmail() {
  useEffect(() => {
    
  }, []);

  const auth = getAuth();

  let verifyEmail = () =>{
    let passAdmin = prompt("Enter Admin Password");
    
    if(passAdmin === "joe"){

      let email = prompt("Enter User Email");
      let pass = prompt("Enter User Password");

      signInWithEmailAndPassword(auth, email, pass)
        .then((userCred)=>{
          let user = userCred.user;

          sendEmailVerification(auth.currentUser)
            .then(()=>{
              alert("Verfication Email Send!");
            }).catch((e)=>{
              alert(e.message);
            })

        }).catch((e)=>{
          alert(e.message);
        })


    }else{
      alert("Wrong Admin Pass")
    }
  }
  

  return <button onClick={verifyEmail}> Verify Email</button>;
}









// let verifyEmail = () =>{
//   let pass = prompt("Enter Admin Pass");
//   const actionCodeSettings = {
//     url: "http://localhost:3000/verifyEmail",
//     handleCodeInApp: true,
//     iOS: {
//       bundleId: "com.example.ios",
//     },
//     android: {
//       packageName: "com.example.android",
//       installApp: true,
//       minimumVersion: "8",
//     },
//   };

//   if (pass === "joe") {
//     const auth = getAuth();
//     let email = prompt("Enter Email you want to verify");
//     sendSignInLinkToEmail(auth, email, actionCodeSettings)
//       .then(() => {
//         window.localStorage.setItem("emailForSignIn", email);
//         alert("Done")
//       })
//       .catch((error) => {
//         const errorCode = error.code;
//         const errorMessage = error.message;
//         console.log(error)
//       });
//   } else {
//     alert("Wrong Pass");
//   }
// }